<template>
  <div>
    <div class="section py-0">
      <div class="textTab mt-30 mb-20">
        <p class="is-size-6 has-text-weight-bold">Que souhaitez-vous faire?</p>
      </div>
      <div class="columns is-multiline is-mobile">
        <div class="column is-6-mobile is-2-tablet"
          v-for="(data, index) in tabData" :key="index">
          <div class="card boxActions pointer mb-5px" @click="$router.push(data.url)">
            <div class="container has-text-centered pt-20">
              <div class="card-image">
                <img :src="data.img">
              </div>
            </div>
          </div>
          <p class=" textTab is-size-6 has-text-weight-bold has-text-centered pb-40">
            {{data.titre}}
          </p>
        </div>
      </div>
    </div>
    <div class="section py-0" v-if="nbrPanNoGeo && nbrPanNoAttach">
      <div class="textTab mt-30 mb-20">
        <p class="is-size-6 has-text-weight-bold">Informations complémentaires</p>
      </div>
      <div class="columns is-multiline is-mobile" ref="cardnogeonoattach">
        <div class="column is-7-mobile is-3-tablet">
          <div
            class="card boxActions pointer mb-5px p-20"
            @click="$router.push({ name: 'panneaux', params: {
              type: 'noGoe'
            } })">
            <article class="media">
              <figure class="media-left">
                <p class="image is-32x32">
                  <img src="static/accueilDash/surface.svg">
                </p>
              </figure>
              <div class="media-content">
                <div class="content">
                  <h3 class="has-text-weight-bold"> {{nbrPanNoGeo}} </h3>
                  <p class="has-text-default is-size-7">Panneau(x) non géolocalisé(s)</p>
                </div>
              </div>
            </article>
          </div>
        </div>
        <div class="column is-7-mobile is-3-tablet">
          <div
            class="card boxActions pointer mb-5px p-20"
            @click="$router.push({ name: 'panneaux', params: {
              type: 'noPhoto'
            } })">
            <article class="media">
              <figure class="media-left">
                <p class="image is-64x64">
                  <img src="static/accueilDash/picture.svg">
                </p>
              </figure>
              <div class="media-content">
                <div class="content">
                  <h3 class="has-text-weight-bold"> {{nbrPanNoAttach}} </h3>
                  <p class="has-text-default is-size-7">Face(s) sans photo</p>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const VenteFacesLc = createNamespacedHelpers('venteFacesLc');

export default {
  name: 'listesActions',
  data() {
    return {
      tabData: [
        {
          img: 'static/accueilDash/VentesFacesLC.png',
          titre: 'Vente faces LC',
          url: '/vente-faces-LC',
        },
        {
          img: 'static/accueilDash/VenteReseauxTemporaires.png',
          titre: 'Vente réseaux temporaires',
          url: '/vente-reseaux-temporaires',
        },
        {
          img: 'static/accueilDash/VentesReseauxLC.png',
          titre: 'Vente réseaux LC',
          url: '/vente-reseaux-LC',
        },
        {
          img: 'static/accueilDash/VenteEcransNumerique.png',
          titre: 'Vente écrans numériques',
          url: '/vente-ecrans-numeriques',
        },
        {
          img: 'static/accueilDash/VentesReseauxNumeriques.png',
          titre: 'Vente réseaux numériques',
          url: '/vente-reseaux-numeriques',
        },
      ],
    };
  },
  computed: {
    ...VenteFacesLc.mapGetters({
      nbrPanNoGeo: 'nbrPanNoGeo',
      nbrPanNoAttach: 'nbrPanNoAttach',
    }),
  },
  methods: {},
  mounted() {},
};
</script>



// WEBPACK FOOTER //
// src/components/tableauDeBord/listesActions.vue